export const newEntityTypes = [
  {
    zoho: "Accounts",
    priority: "CUSTOMER",
    priorityScreen: "CUSTOMERS",
    prioritySubform: "CHANGES_LOG_SUBFORM",
    filterPriority:
      "ORDERS?$filter=ORDNAME eq '${entity_name}'&$expand=DOCTODOLISTLOG_SUBFORM,ORD_CHANGES_LOG_SUBFORM",
  }, //DOCTODOLISTLOG
  {
    zoho: "Sales Orders",
    priority: "ORDERS",
    priorityScreen: "ORDERS",
    prioritySubform: "ORD_CHANGES_LOG_SUBFORM",
    filterPriority: (entity_name) =>
      `ORDERS?$filter=ORDNAME eq '${entity_name}'&$expand=DOCTODOLISTLOG_SUBFORM,ORD_CHANGES_LOG_SUBFORM`,
  }, //DOCTODOLISTLOG
  {
    zoho: "Products",
    priority: "PART",
    priorityScreen: "PART",
    prioritySubform: "CHANGE_LOG_SUBFORM",
  }, //DOCTODOLISTLOG
  {
    zoho: "Contacts",
    priority: "CONTACT",
    priorityScreen: "PHONEBOOK",
    prioritySubform: "CHANGE_LOG_SUBFORM_SUBFORM",
  }, //DOCTODOLISTLOG
  { zoho: "Shipping Certificates", priority: "DOC", priority: "DOCUMENTS_D" }, //DOCTODOLISTLOG
];

export const newEntityTypes3 = {
  CUSTOMER: "לקוחות", //Accounts
  COMPLAIN: "קריאות שירות", //Neo Cases
  CPROF: "הצעות מחיר", //price offers
  ORDERS: "הזמנות", //Sales Orders
  INV: "חשבוניות", //Neo Invoices
  PART: "מוצרים", //Products
  // Reports: "דוחות", //Reports
  // Sales_Certificates: "קבלות", //Sales Certificates
  TINVOICES: "קבלות",
  CONTACT: "אנשי קשר", //Contacts
  DOCNO: "תעודות משלוח", //Shipping Certificates
  DIST: "קווי חלוקה", //Dist Lines
  SERIAL: "אצוות", //Batches
  AGENTS: "סוכנים", //Agents
  // Analytics: "Analytics",
  CALLS: "שיחות", //Calls
  // Products_Listings: "Products Listings",
  COMPANIES: "תתי חברות", //Sub Companies
  BRANCHES: "סניפים", //Branches
  // Streets: "רחובות", //Streets
  // Cities: "ערים", //Cities
  // My_Jobs: "עבודות", //My Jobs
  // Mapping_Items: "Mapping Items",
  // Patient_Health_Events: "Patient Health Events",
  SITE: "אתרים" //Customer_Sites
};
